import './ComponentsForSale.css';
import htmlContent from './ComponentsForSale.html?raw';

class ComponentsForSale {
  constructor(container) {
    this.container = container;
  }

  render() {
    this.container.innerHTML = htmlContent;
    // No specific event listeners needed for this static content page yet
  }
}

export default ComponentsForSale; 